var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9981 43.1176C18.4406 42.9518 19.0488 42.7123 19.7702 42.399C21.3513 41.7124 23.4397 40.6866 25.5096 39.3241C29.7983 36.5008 33.2728 32.7358 33.2728 28.1018V11.3664L18.0001 2.90962L2.72734 11.3664V28.1018C2.72734 32.752 6.20347 36.517 10.4893 39.3347C12.5586 40.6951 14.6464 41.7179 16.2271 42.4021C16.9481 42.7142 17.5558 42.9525 17.9981 43.1176ZM0.181885 9.86618L18.0001 0L35.8182 9.86618V28.1018C35.8182 40.0756 18.0001 45.8182 18.0001 45.8182C18.0001 45.8182 0.181885 40.1062 0.181885 28.1018V9.86618Z",
    fill: "#00A88E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6365 12.7273H24.3637V33.0909H11.6365V12.7273ZM14.1819 30.5455H21.8183V15.2727H14.1819V30.5455Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9092 14H23.091V30.5455H12.9092V14ZM14.1819 29.2727H21.8183V15.2727H14.1819V29.2727Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteFilters);
export default __webpack_public_path__ + "static/media/website-filters.6044ca6651b95b4a768bfb6f2bf3c16a.svg";
export { ForwardRef as ReactComponent };